import { useEffect, useState } from "react";
import { Inbox, MailOpen, Handshake, XCircle } from "lucide-react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip } from "recharts";
import { api } from "@/lib/api";

const StatCard = ({ icon: Icon, label, value, accent }) => (
  <div className="border border-[#232323] bg-[#111111] p-6">
    <div className="flex items-center justify-between">
      <p className="text-xs tracking-[0.2em] text-[#525252] uppercase">{label}</p>
      <Icon size={18} className={accent ? "text-[#C1121F]" : "text-[#525252]"} strokeWidth={1.5} />
    </div>
    <p className="mt-3 text-4xl font-bold tabular-nums">{value}</p>
  </div>
);

export default function Dashboard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/dashboard").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return <p className="text-[#525252]">Yükleniyor...</p>;

  return (
    <div data-testid="admin-dashboard">
      <h1 className="text-2xl font-bold mb-8">Dashboard</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <StatCard icon={Inbox} label="Toplam Başvuru" value={data.total} />
        <StatCard icon={MailOpen} label="Okunmamış" value={data.unread} accent />
        <StatCard icon={Handshake} label="Anlaşıldı" value={data.status_counts["Anlaşıldı"] || 0} />
        <StatCard icon={XCircle} label="Reddedildi" value={data.status_counts["Reddedildi"] || 0} />
      </div>
      <div className="mt-8 border border-[#232323] bg-[#111111] p-6">
        <p className="text-xs tracking-[0.2em] text-[#525252] uppercase mb-6">Son 7 Gün Başvuru</p>
        <div className="h-64" style={{ minHeight: 256 }}>
          <ResponsiveContainer width="100%" height="100%" minWidth={300} minHeight={256}>
            <BarChart data={data.last7}>
              <XAxis dataKey="date" stroke="#525252" fontSize={12} tickLine={false} axisLine={{ stroke: "#232323" }} />
              <YAxis stroke="#525252" fontSize={12} tickLine={false} axisLine={{ stroke: "#232323" }} allowDecimals={false} />
              <Tooltip cursor={{ fill: "#1a1a1a" }} contentStyle={{ background: "#141414", border: "1px solid #262626", borderRadius: 0, color: "#EDEDEA" }} />
              <Bar dataKey="count" name="Başvuru" fill="#8B0000" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
